window.Keywords = new function () {
    this.vars = {
        token: jQuery('meta[name="csrf-token"]').attr('content')
    };

    this.init = function () {
        jQuery('.keyword-wall').after('<div class="interests-indicator"></div>');
        Keywords.setInterestsText();

        jQuery('body').on('click', '.keyword-wall.select-mode .keyword', function (event) {
            event.preventDefault();
            Keywords.selectKeyword(this);
        });

        jQuery('body').on('click', '.keyword-wall .keyword-topic', function (event) {
            event.preventDefault();
            Keywords.openKeywordTopic(this);
        });

        jQuery(window).on('resize', function () {
            jQuery('.keyword-wall .keyword-row').remove();
        });

        jQuery('body').on('keyup', '.keyword-wall .keyword-search', FunMain.debounce(function (event) {
            var search = jQuery(this).val().toLowerCase();
            var $wall = jQuery(this).closest('.keyword-wall');
            Keywords.searchKeywords($wall, search);
        }, 500));

        const $input = $('.keyword-wall .keyword-search');
        const $clearBtn = $('.keyword-wall .clear-input');

        // Show/hide clear button on input
        $input.on('input', function () {
            if ($(this).val().length > 0) {
                $clearBtn.show();
            } else {
                $clearBtn.hide();
            }
        });

        // Clear input on click
        $clearBtn.on('click', function () {
            $input.val('').trigger('input').focus();
            $(this).hide();

            const $wall = $(this).closest('.keyword-wall');
            jQuery($wall).find('.keyword-topic').show();
            jQuery($wall).find('.keyword-topic').removeClass('active');
            jQuery($wall).find('.keyword-row').remove();
        });
    };

    /**
     * Search for keywords using ajax
     *
     * @param object wall - the keyword wall element
     * @param string search - the search term
     */
    this.searchKeywords = function (wall, search) {
        jQuery(wall).find('.keyword-topic').hide();

        $.ajax({
            url: '/keywords/search-keywords',
            type: 'GET',
            data: {
                search: search
            },
            showloader: true,
            success: function (response) {
                jQuery(wall).find('.keyword-row').remove();
                jQuery(wall).find('.keyword-topic').removeClass('active');

                for (var i = 0; i < response.length; i++) {
                    var keyword_topic_id = response[i];
                    jQuery(wall).find('.keyword-topic[data-id="' + keyword_topic_id + '"]').show();
                }
            }
        });
    };

    /**
     * Load keywords from a keyword topic using "wall" js
     *
     * @param obj el - keyword topic clicked
     */
    this.openKeywordTopic = function (el) {
        jQuery('.keyword-wall .keyword-topic').removeClass('active');

        var $clicked = jQuery(el);
        var id = $clicked.data('id');
        var $wall = $clicked.closest('.keyword-wall');
        var $items = $wall.find('.keyword-topic');

        $clicked.addClass('active');

        // Remove previous detail row first
        $wall.find('.keyword-row').remove();

        // Recalculate everything after removal
        setTimeout(function () {
            var clickedTop = $clicked.offset().top;

            var $rowItems = $items.filter(function () {
                return jQuery(this).offset().top === clickedTop;
            });

            var $lastInRow = $rowItems.last();

            $.ajax({
                url: '/keywords/load-keyword-topic/' + id,
                type: 'GET',
                showloader: true,
                success: function (response) {
                    var $detail = jQuery(`
                        <div class="keyword-row hundred">
                            <div class="inner">
                                ${response}
                            </div>
                        </div>
                    `);

                    $detail.insertAfter($lastInRow);
                    Keywords.setSelectedKeywords();
                }
            });
        }, 10); // short delay allows DOM to settle after `.remove()`
    };


    /**
     * Select or deselect a keyword
     *
     * @param obj el - the keyword clicked
     */
    this.selectKeyword = function (el) {
        var max = jQuery(el).closest('.keyword-wall.select-mode').attr('data-max');
        if (!max) {
            max = 999;
        }

        var selected_count = jQuery('.keyword-wall .keyword-ids').find('input').length;
        var id = jQuery(el).attr('data-id');

        jQuery('.keyword-wall .keyword-progress-indicator').css('color', '');

        if (jQuery(el).hasClass('active')) {
            jQuery(el).removeClass('active');
            jQuery('.keyword-wall .keyword-ids').find('input[value="' + id + '"]').remove();
        } else {
            if (selected_count < max) {
                jQuery(el).addClass('active');
                jQuery('.keyword-wall .keyword-ids').append('<input type="checkbox" name="keyword_ids[]" checked value="' + id + '" />');
            } else {
                jQuery('.keyword-wall .keyword-progress-indicator').css('color', 'red');
                alert('You have selected the maximum number of tags. Please deselect ones you no longer want to use.');
            }
        }

        var total_selected = jQuery('.keyword-wall').find('.keyword-ids input').length;
        jQuery('.keyword-wall .keyword-progress-indicator .count').text(total_selected);

        var selected_in_topic = jQuery(el).closest('.keyword-wall').find('.keyword.active').length;
        jQuery(el).closest('.keyword-wall').find('.keyword-topic.active .selected-count').text(selected_in_topic);

        Keywords.setInterestsText();
    };

    /**
     *  Set the interests text based on selected keywords
     */
    this.setInterestsText = function () {
        var $wall = jQuery('.keyword-wall');
        var keyword_ids = $wall.find('.keyword-ids input').map(function () {
            return jQuery(this).val();
        }).get();

        $.ajax({
            url: '/keywords/get-interests',
            type: 'POST',
            data: {
                _token: Keywords.vars.token,
                keyword_ids: keyword_ids
            },
            showloader: true,
            success: function (response) {
                jQuery('.interests-indicator').empty();

                if (response.length) {
                    jQuery('.interests-indicator').append('<span class="label">Based on your selections, your content will show for the following interests: </span>');

                    for (var i = 0; i < response.length; i++) {
                        var interest = response[i];

                        jQuery('.interests-indicator').append('<span class="interest">' + interest + '</span>');
                        if (i < response.length - 1) {
                            jQuery('.interests-indicator').append(', ');
                        }
                    }
                }
            }
        });
    };

    /**
     * When ajax loads in the keywords, set the correct ones to active
     */
    this.setSelectedKeywords = function () {
        jQuery('.keyword-wall.select-mode').find('.keyword').each(function (index, el) {
            var id = jQuery(el).attr('data-id');
            if (jQuery('.keyword-wall .keyword-ids input[value="' + id + '"]').length) {
                jQuery(el).addClass('active');
            }
        });
    };
}

jQuery(document).ready(function ($) {
    Keywords.init();
});
